// Legal content for Axaca Solutions Logistiques
// All content is for an MVP/marketing site. For production use, have it
// reviewed by a lawyer compliant with Quebec / Canada / GDPR requirements.

export const LEGAL_CONTENT = {
  privacy: {
    fr: {
      title: 'Politique de confidentialité',
      updated: 'Dernière mise à jour : 1 janvier 2026',
      intro:
        "Axaca Solutions Logistiques Inc. (« Axaca », « nous », « notre ») s'engage à protéger la vie privée des visiteurs de son site web et de ses clients. Cette politique explique quels renseignements personnels nous recueillons, comment nous les utilisons, et les choix qui s'offrent à vous.",
      sections: [
        {
          heading: '1. Renseignements que nous recueillons',
          body:
            "Nous recueillons uniquement les renseignements nécessaires à la prestation de nos services de courtage de transport et de consultation logistique. Cela peut inclure : votre nom complet, l'entreprise que vous représentez, votre adresse courriel, votre numéro de téléphone, les détails relatifs à vos expéditions (origine, destination, poids, type d'envoi) et toute autre information que vous nous transmettez volontairement via notre formulaire de soumission.",
        },
        {
          heading: '2. Utilisation des renseignements',
          body:
            "Vos renseignements sont utilisés pour : (a) répondre à vos demandes de soumission, (b) coordonner vos expéditions avec nos transporteurs partenaires, (c) vous fournir des conseils logistiques stratégiques, (d) vous envoyer des communications relatives à nos services, et (e) respecter nos obligations légales et réglementaires (CTQ, Transports Canada, douanes, etc.).",
        },
        {
          heading: '3. Partage avec des tiers',
          body:
            "Nous partageons des renseignements limités avec nos transporteurs partenaires uniquement dans la mesure nécessaire à l'exécution de votre expédition. Nous ne vendons jamais vos données personnelles. Nous pouvons divulguer des renseignements si la loi l'exige ou pour protéger nos droits.",
        },
        {
          heading: '4. Conservation des données',
          body:
            "Nous conservons vos renseignements aussi longtemps que nécessaire pour vous fournir nos services et pour respecter nos obligations légales, comptables et fiscales (généralement 7 ans après la fin de la relation commerciale).",
        },
        {
          heading: '5. Sécurité',
          body:
            "Nous mettons en œuvre des mesures techniques et organisationnelles raisonnables pour protéger vos renseignements contre l'accès non autorisé, la perte ou l'altération. Aucune méthode de transmission sur Internet n'est cependant totalement sécuritaire.",
        },
        {
          heading: '6. Vos droits',
          body:
            "Conformément à la Loi 25 du Québec et aux lois canadiennes applicables, vous avez le droit d'accéder à vos renseignements personnels, de les rectifier, de les supprimer, et de retirer votre consentement. Pour exercer ces droits, contactez-nous à info@axaca.solutions.",
        },
        {
          heading: '7. Témoins (cookies)',
          body:
            "Notre site utilise des témoins essentiels pour son fonctionnement. Nous n'utilisons pas de témoins publicitaires tiers. Votre préférence linguistique est sauvegardée localement dans votre navigateur.",
        },
        {
          heading: '8. Modifications',
          body:
            "Nous pouvons mettre à jour cette politique. Toute modification importante sera signalée sur cette page. Nous vous invitons à la consulter régulièrement.",
        },
        {
          heading: '9. Nous joindre',
          body:
            'Pour toute question concernant cette politique : info@axaca.solutions · +1-579-509-2979 · 230 Boul. Sir-Wilfrid-Laurier, Beloeil, QC J3G 4G7.',
        },
      ],
    },
    en: {
      title: 'Privacy Policy',
      updated: 'Last updated: January 1, 2026',
      intro:
        "Axaca Logistics Solutions Inc. (\u201cAxaca\u201d, \u201cwe\u201d, \u201cour\u201d) is committed to protecting the privacy of website visitors and clients. This policy explains what personal information we collect, how we use it, and your choices.",
      sections: [
        {
          heading: '1. Information we collect',
          body:
            'We only collect information needed to provide our freight brokerage and logistics consulting services. This may include: your full name, the company you represent, your email address, your phone number, shipment details (origin, destination, weight, shipment type), and any other information you voluntarily provide through our quote form.',
        },
        {
          heading: '2. How we use information',
          body:
            'Your information is used to: (a) respond to your quote requests, (b) coordinate your shipments with our carrier partners, (c) provide you with strategic logistics advice, (d) send you service-related communications, and (e) meet our legal and regulatory obligations (CTQ, Transport Canada, customs, etc.).',
        },
        {
          heading: '3. Sharing with third parties',
          body:
            'We share limited information with our carrier partners only as needed to execute your shipment. We never sell your personal data. We may disclose information if required by law or to protect our rights.',
        },
        {
          heading: '4. Data retention',
          body:
            'We keep your information for as long as necessary to provide our services and to meet legal, accounting, and tax obligations (generally 7 years after the end of the business relationship).',
        },
        {
          heading: '5. Security',
          body:
            'We implement reasonable technical and organizational measures to protect your information against unauthorized access, loss, or alteration. However, no method of transmission over the Internet is completely secure.',
        },
        {
          heading: '6. Your rights',
          body:
            "In accordance with Quebec\u2019s Law 25 and applicable Canadian laws, you have the right to access, correct, or delete your personal information, and to withdraw your consent. To exercise these rights, contact us at info@axaca.solutions.",
        },
        {
          heading: '7. Cookies',
          body:
            'Our site uses only essential cookies for its operation. We do not use third-party advertising cookies. Your language preference is stored locally in your browser.',
        },
        {
          heading: '8. Changes',
          body:
            'We may update this policy. Any material changes will be posted on this page. We invite you to review it regularly.',
        },
        {
          heading: '9. Contact us',
          body:
            'For any question regarding this policy: info@axaca.solutions \u00b7 +1-579-509-2979 \u00b7 230 Boul. Sir-Wilfrid-Laurier, Beloeil, QC J3G 4G7.',
        },
      ],
    },
  },
  terms: {
    fr: {
      title: 'Termes de services logistiques',
      updated: 'Dernière mise à jour : 1 janvier 2026',
      intro:
        "Les présents termes régissent l'utilisation des services de courtage de transport et de consultation logistique fournis par Axaca Solutions Logistiques Inc. (CTQ INT. # 0-C-31686-I). En utilisant nos services, vous acceptez ces conditions.",
      sections: [
        {
          heading: '1. Nature des services',
          body:
            "Axaca agit à titre d'intermédiaire (courtier) entre les expéditeurs et les transporteurs autorisés. Axaca n'est pas un transporteur et n'exploite pas d'équipement de transport. Le contrat de transport est conclu entre l'expéditeur et le transporteur sélectionné.",
        },
        {
          heading: '2. Soumissions et tarifs',
          body:
            "Les soumissions sont fournies à titre indicatif sur la base des informations communiquées par l'expéditeur. Les tarifs définitifs peuvent varier selon le poids réel, les dimensions, la classe NMFC, les services accessoires (hayon, livraison résidentielle, attente, etc.), les surcharges carburant et les frais imprévus. Une soumission est valide pour 7 jours sauf indication contraire.",
        },
        {
          heading: '3. Responsabilité et assurance',
          body:
            "La responsabilité du transporteur est limitée par les conditions de transport applicables (Canada Conditions de transport, Carmack Amendment aux États-Unis, Convention de Varsovie / Montréal pour l'aérien). Nous recommandons fortement la souscription d'une assurance cargo additionnelle pour les marchandises de valeur. Axaca peut, sur demande, organiser une telle couverture.",
        },
        {
          heading: '4. Obligations du client',
          body:
            "Le client s'engage à fournir des informations exactes et complètes (poids, dimensions, contenu, valeur déclarée, adresses), à emballer ses marchandises adéquatement, à remettre les documents douaniers requis pour les envois internationaux, et à respecter les réglementations applicables (TMD, sanctions économiques, etc.).",
        },
        {
          heading: '5. Marchandises exclues',
          body:
            "Sauf entente écrite préalable, nous ne prenons pas en charge : matières dangereuses non déclarées, animaux vivants, espèces et titres, œuvres d'art irremplaçables, restes humains, marchandises illégales, ou tout autre article interdit par le transporteur sélectionné.",
        },
        {
          heading: '6. Paiement',
          body:
            "Les factures sont payables à la réception, sauf entente de crédit. Tout retard de paiement entraînera des intérêts au taux légal et la suspension possible des services. Le client autorise Axaca à appliquer les paiements aux factures les plus anciennes.",
        },
        {
          heading: '7. Réclamations',
          body:
            "Toute réclamation pour perte, dommage ou retard doit être notifiée par écrit dans un délai conforme aux conditions du transporteur (généralement 14 jours pour les dommages visibles, 60 jours pour les pertes). Axaca assistera le client dans ses démarches mais n'assume pas la responsabilité directe du transporteur.",
        },
        {
          heading: '8. Limitation de responsabilité',
          body:
            "La responsabilité globale d'Axaca, pour tout motif, est limitée au montant des honoraires de courtage perçus pour l'envoi concerné. Axaca n'est responsable d'aucun dommage indirect, incident, spécial ou consécutif.",
        },
        {
          heading: '9. Confidentialité',
          body:
            "Les parties s'engagent à protéger la confidentialité des informations commerciales échangées. Axaca s'engage à utiliser les données du client uniquement aux fins de la prestation des services.",
        },
        {
          heading: '10. Loi applicable et juridiction',
          body:
            "Ces termes sont régis par les lois en vigueur dans la province de Québec, Canada. Tout litige relèvera exclusivement des tribunaux du district judiciaire de Saint-Hyacinthe.",
        },
      ],
    },
    en: {
      title: 'Logistics Services Terms',
      updated: 'Last updated: January 1, 2026',
      intro:
        'These terms govern the use of freight brokerage and logistics consulting services provided by Axaca Logistics Solutions Inc. (CTQ INT. # 0-C-31686-I). By using our services, you agree to these terms.',
      sections: [
        {
          heading: '1. Nature of services',
          body:
            'Axaca acts as an intermediary (broker) between shippers and authorized carriers. Axaca is not a carrier and does not operate transportation equipment. The transportation contract is concluded between the shipper and the selected carrier.',
        },
        {
          heading: '2. Quotes and rates',
          body:
            'Quotes are provided as estimates based on information supplied by the shipper. Final rates may vary based on actual weight, dimensions, NMFC class, accessorial services (liftgate, residential delivery, detention, etc.), fuel surcharges, and unforeseen fees. A quote is valid for 7 days unless otherwise stated.',
        },
        {
          heading: '3. Liability and insurance',
          body:
            'Carrier liability is limited by applicable transportation conditions (Canada Conditions of Carriage, Carmack Amendment in the U.S., Warsaw / Montreal Convention for air). We strongly recommend additional cargo insurance for valuable goods. Axaca can arrange such coverage upon request.',
        },
        {
          heading: '4. Client obligations',
          body:
            'The client undertakes to provide accurate and complete information (weight, dimensions, contents, declared value, addresses), to package goods adequately, to provide required customs documents for international shipments, and to comply with applicable regulations (TDG, economic sanctions, etc.).',
        },
        {
          heading: '5. Excluded goods',
          body:
            'Unless previously agreed in writing, we do not handle: undeclared hazardous materials, live animals, cash and securities, irreplaceable works of art, human remains, illegal goods, or any other item prohibited by the selected carrier.',
        },
        {
          heading: '6. Payment',
          body:
            'Invoices are payable upon receipt unless a credit agreement is in place. Any late payment will incur legal-rate interest and potential service suspension. The client authorizes Axaca to apply payments to the oldest outstanding invoices first.',
        },
        {
          heading: '7. Claims',
          body:
            "Any claim for loss, damage, or delay must be notified in writing within the deadline applicable under the carrier's terms (typically 14 days for visible damage, 60 days for losses). Axaca will assist the client but does not assume direct carrier liability.",
        },
        {
          heading: '8. Limitation of liability',
          body:
            "Axaca\u2019s total liability, for any cause, is limited to the brokerage fees collected for the affected shipment. Axaca is not liable for any indirect, incidental, special, or consequential damages.",
        },
        {
          heading: '9. Confidentiality',
          body:
            'Parties undertake to protect the confidentiality of commercial information exchanged. Axaca undertakes to use client data solely for the purpose of providing the services.',
        },
        {
          heading: '10. Governing law and jurisdiction',
          body:
            'These terms are governed by the laws in force in the province of Quebec, Canada. Any dispute shall fall exclusively under the courts of the judicial district of Saint-Hyacinthe.',
        },
      ],
    },
  },
};
